module.exports = __webpack_public_path__ + "static/img/project2.4fb31a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project2.jpg
// module id = 743
// module chunks = 1